import { useContext } from 'react'
import { SnowplowContext } from '@contexts/SnowplowContext'
import { buildSnowplowClientTracker } from '@helpers/core/buildSnowplowClientTracker'

export const useEventTracker = () => {
  const { defaultPropertyValue } = useContext(SnowplowContext) || {}

  return {
    track: buildSnowplowClientTracker(defaultPropertyValue),
  }
}
